export default __webpack_public_path__ + "static/media/Home.bccc80e7.svg";